var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LLDialog"},[(_vm.slotsVisibility.title)?_c('h3',{staticClass:"LLDialog__title"},[_vm._t("title")],2):_vm._e(),_c('div',{staticClass:"LLDialog__content"},[_vm._t("content")],2),(_vm.slotsVisibility.actions)?_c('div',{staticClass:"LLDialog__actions"},[_vm._t("actions")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }